import { Stack } from 'expo-router';

import GoBackButton from '@/components/buttons/GoBackButton';
import Title from '@/components/Title';
import PlatformContainer from '@/components/web/PlatformContainer';
import { i18n } from '@/utils/i18n';
import { SafeAreaView } from 'react-native-safe-area-context';
import { StyleSheet } from 'react-native';

const MessagesLayout = () => {
  return (
    <PlatformContainer contentCustomClassnames="flex">
      <SafeAreaView style={styles.flexOne} edges={['bottom']}>
        <Stack>
          <Stack.Screen
            name="index"
            options={{
              headerShown: true,
              headerShadowVisible: false,
              headerBackVisible: false,
              headerTitle: () => <Title label={i18n.t('messages.title')} />,
              headerLeft: () => <GoBackButton />
            }}
          />
          <Stack.Screen
            name="[volunteerEventId]"
            options={{
              headerShown: true,
              headerShadowVisible: true,
              headerBackVisible: false,
              headerLeft: () => <GoBackButton />
            }}
          />
        </Stack>
      </SafeAreaView>
    </PlatformContainer>
  );
};

export default MessagesLayout;

const styles = StyleSheet.create({
  flexOne: {
    flex: 1
  }
});
